//-- Copyright (c) 2021 TMT Insights Group, LLC
import TableStatus from '../../_common/Table/TableStatus';
import ProgressCircle from './ProgressCircle';
import TransferQueueExpand, { TransferQueueExpandProps } from './TransferQueueExpand';
import TransferQueueAction from './TransferQueueAction';
import DateTimeDisplay from '../../_common/DateTimeDisplay';
import { insertWordBreaks } from '@/_utils/utils';
import { TransferQueueItem } from '@/redux/slices/slice_types';
import UserDisplay from '../../_common/AssigneeSelect/UserDisplay';

export default {
  expandable: {
    isExpandable: true,
    render: (props: TransferQueueExpandProps) => <TransferQueueExpand {...props} />
  },
  created: {
    label: 'Created',
    render: (cell: TransferQueueItem['created']) => <DateTimeDisplay>{cell}</DateTimeDisplay>,
    width: 80
  },
  task_type: {
    label: 'Action',
    render: (cell: TransferQueueItem['task_type']) => <TransferQueueAction action={cell} />
  },
  filename: {
    label: 'Filename',
    minWidth: 300,
    render: (_cell: any, row: TransferQueueItem) => insertWordBreaks(getFileName(row.task_call))
  },
  source: {
    label: 'Source',
    render: (_cell: any, row: TransferQueueItem) => <div>{row.task_call?.args?.[0]}</div>
  },
  destination: {
    label: 'Destination',
    render: (_cell: any, row: TransferQueueItem) => {
      if (row.task_type.includes('download')) {
        return <UserDisplay user={row.created_by} />;
      } else {
        return row.task_call?.args?.[2];
      }
    }
  },
  created_by: {
    label: 'Initiated By',
    render: (cell: TransferQueueItem['created_by']) => <UserDisplay user={cell} />
  },
  status: {
    label: 'Status',
    render: (cell: TransferQueueItem['status']) => <TableStatus status={cell} />
  },
  progress: {
    label: 'Progress',
    width: 100,
    disableSort: true,
    render: (_cell: any, row: TransferQueueItem) => (
      <ProgressCircle progress={row.progress} status={row.status} exception={row?.task_result?.exception} errorMessage={row.task_error_msg} />
    )
  }
};

function getFileName(file: TransferQueueItem['task_call'] = {}) {
  const fileName = file?.args?.[1] || '';
  return fileName.split('/').pop();
}
